<template>
  <div class="home-box flex flex-d ai-c">
    <img src="@/assets/officialAccount/bg.jpg" alt="" class="bgImg">
    <img src="@/assets/officialAccount/title.png" alt="" class="oneTitle allPosition">
    <div class="main">
      <div class="content flex jc-c ai-c">
        <div class="lable">姓名*：</div>
        <input type="text" class="inpStyle" v-model="name" placeholder="请输入姓名">
      </div>
      <div class="content flex jc-c ai-c">
        <div class="lable">电话*：</div>
        <input type="text" class="inpStyle" v-model="phone" placeholder="请输入电话" inputmode="tel">
      </div>
      <div class="content flex jc-c ai-c">
        <div class="lable">邮箱：</div>
        <input type="text" class="inpStyle" v-model="email" placeholder="请输入邮箱" inputmode="email">
      </div>
      <div class="content flex jc-c ai-c">
        <div class="lable">公司全称*：</div>
        <input type="text" class="inpStyle" v-model="companyName" placeholder="请输入公司全称">
      </div>
      <div class="content flex jc-c ai-c">
        <div class="lable">公司行业*：</div>
        <input type="text" class="inpStyle" v-model="companyIndustry" placeholder="请输入公司行业">
      </div>
      <div class="content flex jc-c ai-fa">
        <div class="lable">数据需求：</div>
        <textarea cols="30" rows="5" class="inpStyle textareaStyle" v-model="dataRequirements"></textarea>
      </div>
      <div class="btn" @click="submit">提交</div>
    </div>
    <div class="foot">
      <div class="footLable">北京星图数网科技有限公司</div>
      <div class="footLable">电话：400-066-9026</div>
      <div class="footLable">邮箱：info@syntun.com</div>
      <div class="footLable">网址：www.syntun.com.cn</div>
      <div class="footLable">北京市北京经济开发区科创十三街锋创科技园8号楼5层</div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import axios from 'axios'
export default {
  name: 'officialAccount',
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      companyName: '',
      companyIndustry: '',
      dataRequirements: '',
      isSuccess: false,
    }
  },
  components: { Toast },
  mounted() {},
  computed: {},
  methods: {
    //提交表单
    submit() {
      if (this.isSuccess) return
      if (this.name == '') {
        Toast.fail({
          message: '姓名不能为空',
          className: 'toastStyle',
        })
        return
      }
      if (this.phone == '') {
        Toast.fail({
          message: '电话不能为空',
          className: 'toastStyle',
        })
        return
      }
      if (this.companyName == '') {
        Toast.fail({
          message: '公司全称不能为空',
          className: 'toastStyle',
        })
        return
      }
      if (this.companyIndustry == '') {
        Toast.fail({
          message: '公司行业不能为空',
          className: 'toastStyle',
        })
        return
      }
      //判断手机号格式是否正确
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast.fail({
          message: '请输入正确的手机号',
          className: 'toastStyle',
        })
        return
      }
      //判断邮箱格式是否正确
      if (
        this.email != '' &&
        !/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(this.email)
      ) {
        Toast.fail({
          message: '请输入正确的邮箱',
          className: 'toastStyle',
        })
        return
      }

      //  https://infinitytest.syntun.com/data/insertDataRequirements
      //axios,post请求
      axios
        .post('https://infinitytest.syntun.cn/data/insertDataRequirements', {
          name: this.name,
          phone: this.phone,
          email: this.email,
          companyName: this.companyName,
          companyIndustry: this.companyIndustry,
          dataRequirements: this.dataRequirements,
        })
        .then((res) => {
          if (res.data.code == 200) {
            Toast.success({
              message: '提交成功！',
              className: 'toastStyle toastBg',
              duration: 0,
              overlay: true,
            })
            this.isSuccess = true
          } else {
            Toast.fail({
              message: '提交失败，请联系管理员！',
              className: 'toastStyle',
            })
          }
        })
        .catch((err) => {
          Toast.fail({
            message: '提交失败，请联系管理员！',
            className: 'toastStyle',
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.home-box {
  overflow-x: hidden;
  position: relative;
  font-family: 'Source Han Sans CN';
  .bgImg {
    width: 100%;
    height: 100%;
  }
  .oneTitle {
    position: absolute;
    top: 140px;
    width: 465px;
    height: 103px;
    cursor: pointer;
  }
  .main {
    width: 100vw;
    position: absolute;
    top: 340px;
    .content {
      margin-bottom: 60px;
      .lable {
        width: 160px;
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #fee3a9;
        text-align: left;
      }
      .inpStyle {
        width: 440px;
        height: 50px;
        border: 2px solid #7f5f44;
        border-radius: 10px;
        background-color: rgba(0, 0, 0, 0);
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #977f65;
        padding: 0 20px;
      }
      .textareaStyle {
        height: auto;
      }
    }
    .btn {
      width: 200px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 10px;
      background: url('~@/assets/officialAccount/btn.png') no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      margin: 0 auto;
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .foot {
    width: 100vw;
    position: absolute;
    top: 1300px;
    left: 80px;
    .footLable {
      text-align: left;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 50px;
    }
  }
}
::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #977f65;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #977f65;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #977f65;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #977f65;
}
</style>